import { useQuery } from "@tanstack/react-query";
import { engineError } from "@/lib/engine-error";
import type { ProjectDetail } from "@/lib/profitability-api";
import { queryKeys } from "@/lib/query";

export function useProjectDetail(demandId: string, range?: string) {
  return useQuery({
    queryKey: [...queryKeys.projectDetail(demandId), range ?? "default"],
    queryFn: async (): Promise<ProjectDetail> => {
      const response = await fetch(
        `/api/projects/${encodeURIComponent(demandId)}${range ? `?range=${range}` : ""}`,
      );
      if (!response.ok) {
        throw await engineError(response, "Could not load this project");
      }
      return response.json();
    },
    enabled: demandId.length > 0,
    // Month-end close data. Re-fetching on every window focus would hammer the
    // engine for numbers that change once a month.
    staleTime: 5 * 60 * 1000,
  });
}
